import { Locales } from "@simplyk/common";

import { useLocaleContext } from "../contexts/LocaleContext";
import { useTranslate } from "../hooks/useTranslate";

import { NewTabLink } from "./Link/NewTabLink";

export const ContactSupportLink = () => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  return (
    <NewTabLink
      href={locale === Locales.EN ? "https://www.zeffy.com/home/contact" : "https://fr.zeffy.com/home/contact"}
    >
      {t("dashboard", "common.ContactSupport")}
    </NewTabLink>
  );
};
